import { ChemistryLiteElement } from '@adornis/chemistry/chemistry-lite-element.js';
import { customElement } from 'lit/decorators.js';

/**
 * Vertical rule
 *
 * @element tr-vr
 */
@customElement('tr-vr')
export class TrVerticalRule extends ChemistryLiteElement {
  override styles = () => [
    { flex: 'none', display: 'block', height: '100%', width: '1px', background: this.colors.neutral.shade(100) },
  ];
}
